import NewIntegrationStepsView, { NewIntegrationStep as NIS } from './view'

export const NewIntegrationStep = NIS
export default NewIntegrationStepsView